import { Loader2 } from 'lucide-react';

interface LoadingPanelProps {
  message?: string;
  className?: string;
}

export function LoadingPanel({ message = 'Chargement en cours...', className = '' }: LoadingPanelProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-20 gap-3 text-muted-foreground bg-card rounded-lg shadow-sm ${className}`}>
      <Loader2 className="h-8 w-8 animate-spin text-brand" />
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
}
